<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" offset-md="3" class="white elevation-4">
        <h1 class="text-center headline mb-6">Reset Password</h1>
        <v-form>
          <v-text-field
            type="email"
            v-model="email"
            label="E-mail"
            required
          ></v-text-field>
          <p class="body text-center">
            Ready to go?
            <router-link to="login">Log In</router-link>
          </p>
          <v-btn block rounded dark color="orange" class="mt-6" @click="submit">
            <span v-if="!loading">Recover Password</span>
            <v-progress-circular
              indeterminate
              color="white"
              v-if="loading"
            ></v-progress-circular>
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn color="pink" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PasswordReset",
  data() {
    return {
      email: null,
      loading: false,
      snackbar: {
        show: false,
        text: "",
      },
    };
  },
  methods: {
    ...mapActions({
      recover: "users/recoverPassword",
    }),
    async submit() {
      if (!this.email) {
        this.snackbar = {
          show: true,
          text: "Please complete all fields",
        };
        return;
      }

      this.loading = true;

      try {
        await this.recover(this.email);
        this.snackbar = {
          show: true,
          text: "Please check your email for further instructions"
        }
      } catch (err) {
        this.snackbar = {
          show: true,
          text: err.message,
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 10%;
}
</style>
